import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { Link } from "react-router-dom";
import { environment } from '../environment/production';
import $ from 'jquery';

function UserPersonalDetails() {
  const navigate = useNavigate();

  const [minFromDate, setMinFromDate] = useState(new Date())
  const [maxFromDate, setMaxFromDate] = useState(new Date())
  const [minToDate, setMinToDate] = useState(new Date())
  const [maxToDate, setMaxToDate] = useState(new Date())

  const [fileData, setFileData] = useState({
    fileName: null,
    base64URL: ''
  })

  const [picUpload, setPicUpload] = useState({
    image: '',
    imagePath: ''
  })

  const [cityDetails, setCityDetails] = useState([])
  const [presentCityDetails, setPresentCityDetails] = useState([])
  const [permanentCityDetails, setPermanentCityDetails] = useState([])
  const [officeCityDetails, setOfficeCityDetails] = useState([])
  const [stateDetails, setStateDetails] = useState([])
  const [locationPreferenceDetails, setLocationPreferenceDetails] = useState([])

  const [showPref2, setShowPref2] = useState(true);
  const [showPref3, setShowPref3] = useState(true);

  const [checkboxValue, setCheckboxValue] = useState({
    title: '',
    category: '',
    post_applied: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
  })

  const [apiCall, setApiCall] = useState(0)
  const [postDetails, setPostDetails] = useState([])
  const [personalDetails, setPersonalDetails] = useState({ data: '' })

  const options = {
    headers: {
      'Authorization': sessionStorage.getItem("access_token")
    }
  }

  // const getBase64 = (file) => {
  //   if (!file) return;

  //   setFileData({ ...fileData, fileName: file.name });

  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);

  //   reader.onload = () => {
  //     const baseURL = reader.result;
  //     setFileData({ ...fileData, base64URL: baseURL });

  //     const ext = file.name.split(".").pop().toLowerCase();
  //     if (ext === "jpg" || ext === "jpeg") {
  //       axios.post(
  //         environment.apiUrl + "/Personal/DocUpload",
  //         JSON.stringify({
  //           user_id: sessionStorage.getItem("user_id"),
  //           image: baseURL
  //         }),
  //         { headers: options.headers }
  //       )
  //         .then((resp) => {
  //           alert(resp.data.msg);

  //           if (resp.data.status === 1 && resp.data.fileName) {
  //             // ✅ Update the uploaded image in both states
  //             setPicUpload((prev) => ({
  //               ...prev,
  //               imagePath: resp.data.fileName
  //             }));

  //             setFormData((prev) => ({
  //               ...prev,
  //               photo_path: resp.data.fileName
  //             }));
  //           }
  //         })
  //         .catch((err) => {
  //           console.error("Upload error:", err);
  //         });
  //     } else {
  //       alert("Only JPG or JPEG is allowed");
  //     }
  //   };
  // };

  const [selectedFile, setSelectedFile] = useState(null);

const handlePhotoUpload = () => {
  if (!selectedFile) {
    alert("Please select a file first");
    return;
  }
  
  const reader = new FileReader();
  reader.readAsDataURL(selectedFile);
  reader.onload = () => {
    const baseURL = reader.result;
    const arr = selectedFile.name.split(".");
    const ext = arr[arr.length - 1].toLowerCase();
    
    if (ext === "jpg" || ext === "jpeg") {
      axios.post(
        environment.apiUrl + "/Personal/DocUpload",
        JSON.stringify({
          user_id: sessionStorage.getItem("user_id"),
          image: baseURL
        }),
        { headers: options.headers }
      )
      .then((resp) => {
        alert(resp.data.msg);
        if (resp.data.fileName) {
          setPicUpload(prev => ({ ...prev, imagePath: resp.data.fileName }));
        }
      })
      .catch((err) => {
        console.error("Upload failed:", err);
        alert("Failed to upload photo");
      });
    } else {
      alert("Only JPG or JPEG is allowed");
    }
  };
};


  const getPostDetails = () => {
    axios.post(environment.apiUrl + `/Personal/getPostDetails`,
      JSON.stringify({ user_id: parseInt(sessionStorage.getItem('user_id')) }),
      { headers: options.headers })
      .then((response) => {
        if (response.data) {
          setPostDetails(response.data);
        }
      })
  }

  const getLocationPreferenceByPost = (positionId) => {
    axios.post(environment.apiUrl + "/Master/getLocationPreferenceByPost",
      JSON.stringify({ position_id: positionId }),
      { headers: options.headers })
      .then((response) => {
        if (response.data.status === 1) {
          const locs = response.data.location_preferenceData || [];
          setLocationPreferenceDetails(locs);

          if (locs.length === 1) {
            setShowPref2(false);
            setShowPref3(false);
            setCheckboxValue(prev => ({
              ...prev,
              location_preference1: locs[0].location_preference
            }))
          } else if (locs.length === 2) {
            setShowPref2(true);
            setShowPref3(false);
          } else {
            setShowPref2(true);
            setShowPref3(true);
          }
        }
      });
  };

  const getCityDetails = () => {
    axios.post(environment.apiUrl + "/Master/getCityList")
      .then((response) => {
        if (response.data.status === 1) {
          setCityDetails(response.data.cityData)
        }
      })
  }

  const getPersonalDetails = () => {
    axios.post(environment.apiUrl + `/Personal/getPersonalDetails`,
      JSON.stringify({ user_id: parseInt(sessionStorage.getItem('user_id')) }),
      { headers: options.headers })
      .then((response) => {

        if (response['data']['status'] == 1) {
          const data = response['data']['data'];
          setPersonalDetails({ data: data })
          setPicUpload({ ...picUpload, imagePath: data['photo_path'] })
          setCheckboxValue({
            ...checkboxValue,
            title: data['title'],
            category: data['category'],
            post_applied: data['PositionID'],
            location_preference1: data['location_preference1'],
            location_preference2: data['location_preference2'],
            location_preference3: data['location_preference3'],
            present_state: data['present_state'],
            present_district: data['present_district'],
            present_pincode: data['present_pincode'],
            permanent_state: data['permanent_state'],
            permanent_district: data['permanent_district'],
            permanent_pincode: data['permanent_pincode'],
            office_state: data['office_state'],
            office_district: data['office_district'],
            office_pincode: data['office_pincode']
          })

          // Load cities for each state that has a value
          if (data['present_state']) {
            getCityDetailsByStateId(data['present_state'], 'present');
          }
          if (data['permanent_state']) {
            getCityDetailsByStateId(data['permanent_state'], 'permanent');
          }
          if (data['office_state']) {
            getCityDetailsByStateId(data['office_state'], 'office');
          }
        }
      })
  }

  useEffect(() => {
    if (apiCall === 0) {
      getPostDetails();
      getPersonalDetails();
      getStateDetails();
      getCityDetails();
    }

    axios.post(environment.apiUrl + "/Personal/getPersonalDetails", { user_id: sessionStorage.getItem("user_id") }, { headers: options.headers })
      .then((response) => {
        console.log("Personal Details:", response);
        if (response.data.status === 1) {
          const data = response.data.data;

          setFormData(data);

          // Sync values for dropdowns
          setCheckboxValue(prev => ({
            ...prev,
            post_applied: data.PositionID || '',
            location_preference1: data.location_preference1 || '',
            location_preference2: data.location_preference2 || '',
            location_preference3: data.location_preference3 || ''
          }));

          // ✅ Load location preferences list if we already have a post applied
          if (data.post_applied) {
            console.log("Fetching location preferences for post:", postDetails);
            const selectedPost = postDetails.find(
              p => p.PositionName === data.post_applied
            );
            console.log("Selected Post:", selectedPost);
            if (selectedPost) {
              getLocationPreferenceByPost(selectedPost.PositionID);
            }
          }
        }
      });


    setApiCall(1);
  }, [apiCall, postDetails]);


  let checked = personalDetails.data.permanent_address !== '' ? true : false;


  // Define getLocationPreferences separately so it can be reused
  const getLocationPreferences = (positionId) => {
    axios.post(environment.apiUrl + "/Master/getLocationPreferenceByPost", {
      position_id: positionId
    }).then((response) => {
      if (response.data.status === 1) {
        setLocationPreferenceDetails(response.data.location_preferenceData);
      }
    });
  };

  // OnChange handler for Post Applied dropdown
  const handlePostAppliedChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formdata, post_applied: value });

    if (value) {
      getLocationPreferences(value);
    } else {
      setLocationPreferenceDetails([]);
    }
  };

  const [checkbox, setCheckbox] = useState(false);
  const [formdata, setFormData] = useState({
    user_id: null,
    post_applied: '',
    title: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_title: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    date_of_birth: '',
    mobile_no: '',
    email_id: '',
    category: '',
    designation: '',
    present_address: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_address: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_address: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    date_of_entry_into_govt_service: '',
    date_of_retirement_from_govt_service: '',
    current_designation: '',
    current_pay_matrix: '',
    no_of_yrs_current_pay_matrix: '',
    state_whether_applicable_for_post_applying: ''
  });

  const [errormsg, setErrorMsg] = useState({
    post_applied: '',
    title: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_title: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    date_of_birth: '',
    mobile_no: '',
    email_id: '',
    category: '',
    designation: '',
    present_address: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_address: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_address: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    date_of_entry_into_govt_service: '',
    date_of_retirement_from_govt_service: '',
    current_designation: '',
    current_pay_matrix: '',
    no_of_yrs_current_pay_matrix: ''
  });

  const [permanentAddress, setPermanentAddress] = useState('')
  const [permanentState, setPermanentState] = useState('')
  const [permanentDistrict, setPermanentDistrict] = useState('')
  const [permanentPincode, setPermanentPincode] = useState('')

  const [formerror, setFormError] = useState({
    post_applied: ''
  })

  /*
  function getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}
*/
  const handlePicUpload = (e) => {
    e.preventDefault();

    //console.log(atob(new Blob([e.target.files[0]], {type:"text/plain"})))
    //getBase64(e.target.files[0], (result) => {

    axios.post(environment.apiUrl + "/Personal/DocUpload", JSON.stringify({ user_id: sessionStorage.getItem("user_id"), image: fileData.base64URL }), { headers: (options.headers) })
      .then((resp) => {
        if (resp['data']['status'] == 1) {
          alert(resp['data']['msg'])
        } else {
          alert(resp['data']['msg'])
        }
      })


  }

  function fromDateChange(event: any) {

    setMaxFromDate(document.getElementById("date_of_entry_into_govt_service").value)
  }


  const userRegistrationAPI = (e) => {
    // e.preventDefault();
    axios.post(environment.apiUrl + `/Personal/CreateUpdate`, JSON.stringify(formdata), { headers: options.headers })

      .then((response) => {
        if (response['data']['status'] == 1) {
          $('.wizard-btn').attr('disabled', false)

          alert(response['data']['msg'])
        } else {
          alert(response['data']['msg'])
        }

      })

  }


  function handleCheckBoxAddress(e) {

    if (e.target.checked == true) {
      // $('#permanent_address').val(permanentAddress)
      // $('#permanent_district').val(permanentDistrict)
      // $('#permanent_state').val(permanentState)
      // $('#permanent_pincode').val(permanentPincode)
      document.getElementById('permanent_address').value = document.getElementById('present_address').value;
      document.getElementById('permanent_district').value = document.getElementById('present_district').value;
      document.getElementById('permanent_state').value = document.getElementById('present_state').value;
      document.getElementById('permanent_pincode').value = document.getElementById('present_pin_code').value;
    } else {
      // $('#permanent_address').val('')
      // $('#permanent_district').val('')
      // $('#permanent_state').val('')
      // $('#permanent_pincode').val('')
      document.getElementById('permanent_address').value = '';
      document.getElementById('permanent_district').value = '';
      document.getElementById('permanent_state').value = '';
      document.getElementById('permanent_pincode').value = '';
    }
  }

  const handleFormValidation = () => {
    let image = getPersonalDetails() !== '' ? false : true;

    if ($('#email_id').val() === '') {
      alert("Email id is required");
      return false;
    }
    if ($('#post_applied').val() === '') {
      alert("Post applied is required");
      return false;
    }
    if ($('#title').val() === '') {
      alert("Title is required");
      return false;
    }
    if ($('#first_name').val() === '') {
      alert("First name is required");
      return false;
    }
    if ($('#last_name').val() === '') {
      alert("Last name is required");
      return false;
    }
    if ($('#dob').val() === '') {
      alert("Date of birth is required");
      return false;
    }
    if ($('#mobile_no').val() === '') {
      alert("Mobile number is required");
      return false;
    }
    if ($('#mobile_no').val().length !== 10) {
      alert("Mobile number should be 10 digits");
      return false;
    }
    if ($('#category').val() === '') {
      alert("Category is required");
      return false;
    }
    if ($('#present_address').val() === '') {
      alert("Present address is required");
      return false;
    }
    if ($('#present_state').val() === '') {
      alert("Present state is required");
      return false;
    }
    if ($('#present_district').val() === '') {
      alert("Present district is required");
      return false;
    }
    if ($('#present_pin_code').val() === '') {
      alert("Present pincode is required");
      return false;
    }
    if ($('#present_pin_code').val().length !== 6) {
      alert("Present pincode should be 6 digits");
      return false;
    }
    if ($('#permanent_address').val() === '') {
      alert("Permanent address is required");
      return false;
    }
    if ($('#permanent_state').val() === '') {
      alert("Permanent state is required");
      return false;
    }
    if ($('#permanent_district').val() === '') {
      alert("Permanent district is required");
      return false;
    }
    if ($('#permanent_pincode').val() === '') {
      alert("Permanent pincode is required");
      return false;
    }
    if ($('#permanent_pincode').val().length !== 6) {
      alert("Permanent pincode should be 6 digits");
      return false;
    }
    if ($('#location_preference1').val() === '') {
      alert("Location preference 1 is required");
      return false;
    }

    if ($('#location_preference2').is(':visible') && $('#location_preference2').val() === '') {
      alert("Location preference 2 is required");
      return false;
    }
    if ($('#location_preference3').is(':visible') && $('#location_preference3').val() === '') {
      alert("Location preference 3 is required");
      return false;
    }

    if ($('#date_of_entry_into_govt_service').val() === '') {
      alert("Date of Entry into Government Service is Required");
      return false;
    }
    if ($('#date_of_retirement_from_govt_service').val() === '') {
      alert("Date of Retirement from Government Service is Required");
      return false;
    }
    if ($('#current_designation').val() === '') {
      alert("Current designation is Required");
      return false;
    }
    if ($('#current_pay_matrix').val() === '') {
      alert("Current pay matrix is Required");
      return false;
    }
    if ($('#no_of_yrs_current_pay_matrix').val() === '') {
      alert("No. of years in current pay matrix is Required");
      return false;
    }
    if ($('#state_whether_applicable_for_post_applying').val() === '') {
      alert("State whether applicable for post applying field is required");
      return false;
    }

    if (image && $('#image').val() === '') {
      alert("Image is required");
      return false;
    }
    return true;


    // ✅ All validations passed
    userRegistrationAPI();
  };




  function handleFormSubmit(e) {
    e.preventDefault();

    const updatedForm = { ...formdata };
    updatedForm.user_id = parseInt(sessionStorage.getItem("user_id"));

    // Fill in basic form fields using ID selectors
    updatedForm.title = $('#title').val();
    updatedForm.first_name = $('#first_name').val();
    updatedForm.middle_name = $('#middle_name').val();
    updatedForm.last_name = $('#last_name').val();
    updatedForm.date_of_birth = $('#dob').val();
    updatedForm.mobile_no = $('#mobile_no').val();
    updatedForm.email_id = $('#email_id').val();
    updatedForm.category = $('#category').val();
    updatedForm.present_address = $('#present_address').val();
    updatedForm.present_state = checkboxValue.present_state;
    updatedForm.present_district = checkboxValue.present_district;
    updatedForm.present_pincode = $('#present_pin_code').val();
    updatedForm.permanent_address = $('#permanent_address').val();
    updatedForm.permanent_state = checkboxValue.permanent_state;
    updatedForm.permanent_district = checkboxValue.permanent_district;
    updatedForm.permanent_pincode = $('#permanent_pincode').val();
    updatedForm.office_address = $('#office_address').val();
    updatedForm.office_state = checkboxValue.office_state;
    updatedForm.office_district = checkboxValue.office_district;
    updatedForm.office_pincode = $('#office_pincode').val();
    updatedForm.location_preference1 = $('#location_preference1').val();
    updatedForm.location_preference2 = $('#location_preference2').length ? $('#location_preference2').val() : "";
    updatedForm.location_preference3 = $('#location_preference3').length ? $('#location_preference3').val() : "";
    updatedForm.date_of_entry_into_govt_service = $('#date_of_entry_into_govt_service').val();
    updatedForm.date_of_retirement_from_govt_service = $('#date_of_retirement_from_govt_service').val();
    updatedForm.current_designation = $('#current_designation').val();
    updatedForm.current_pay_matrix = $('#current_pay_matrix').val();
    updatedForm.no_of_yrs_current_pay_matrix = $('#no_of_yrs_current_pay_matrix').val();
    updatedForm.state_whether_applicable_for_post_applying = $('#state_whether_applicable_for_post_applying').val();

    const postId = $('#post_applied').val();
    console.log("updatedForm: ", updatedForm)
    // First get PositionName, then validate & submit
    axios.post(
      environment.apiUrl + `/Personal/getPostDetailsById`,
      JSON.stringify({ PositionId: postId }),
      { headers: options.headers }
    )
      .then((response) => {
        if (response.data && response.data[0]) {
          updatedForm.post_applied = response.data[0].PositionName;
        } else {
          updatedForm.post_applied = "";
        }

        setFormData(updatedForm);

        // Run validation after updating post_applied
        if (handleFormValidation()) {
          // Filter out unwanted fields that shouldn't be sent to backend
          const cleanedForm = {
            user_id: updatedForm.user_id,
            id: updatedForm.id,
            post_applied: updatedForm.post_applied,
            title: updatedForm.title,
            first_name: updatedForm.first_name,
            middle_name: updatedForm.middle_name,
            last_name: updatedForm.last_name,
            date_of_birth: updatedForm.date_of_birth,
            mobile_no: updatedForm.mobile_no,
            email_id: updatedForm.email_id,
            category: updatedForm.category,
            designation: updatedForm.designation || '',
            present_address: updatedForm.present_address,
            present_state: updatedForm.present_state,
            present_district: updatedForm.present_district,
            present_pincode: updatedForm.present_pincode,
            permanent_address: updatedForm.permanent_address,
            permanent_state: updatedForm.permanent_state,
            permanent_district: updatedForm.permanent_district,
            permanent_pincode: updatedForm.permanent_pincode,
            office_address: updatedForm.office_address,
            office_state: updatedForm.office_state,
            office_district: updatedForm.office_district,
            office_pincode: updatedForm.office_pincode,
            location_preference1: updatedForm.location_preference1,
            location_preference2: updatedForm.location_preference2,
            location_preference3: updatedForm.location_preference3,
            date_of_entry_into_govt_service: updatedForm.date_of_entry_into_govt_service,
            date_of_retirement_from_govt_service: updatedForm.date_of_retirement_from_govt_service,
            current_designation: updatedForm.current_designation,
            current_pay_matrix: updatedForm.current_pay_matrix,
            no_of_yrs_current_pay_matrix: updatedForm.no_of_yrs_current_pay_matrix,
            state_whether_applicable_for_post_applying: updatedForm.state_whether_applicable_for_post_applying,
            PositionID: updatedForm.PositionID,
            father_title: updatedForm.father_title || '',
            father_first_name: updatedForm.father_first_name || '',
            father_middle_name: updatedForm.father_middle_name || '',
            father_last_name: updatedForm.father_last_name || '',
            photo_path: updatedForm.photo_path || ''
          };

          axios.post(environment.apiUrl + `/Personal/CreateUpdate`, JSON.stringify(cleanedForm), { headers: options.headers })

            .then((response) => {
              if (response['data']['status'] == 1) {
                $('.wizard-btn').attr('disabled', false)

                alert(response['data']['msg'])
              } else {
                alert(response['data']['msg'])
              }

            })
        }
      })
      .catch((err) => {
        console.error("Error fetching post details:", err);
      });
  }

  function getCityDetailsByStateId(value, purpose = 'present') {

    axios.post(environment.apiUrl + "/Master/getCityByStateId", JSON.stringify({ state_id: value }))
      .then((response) => {

        if (response.data.status == 1) {
          if (purpose === 'present') {
            setPresentCityDetails(response.data.cityData)
          } else if (purpose === 'permanent') {
            setPermanentCityDetails(response.data.cityData)
          } else if (purpose === 'office') {
            setOfficeCityDetails(response.data.cityData)
          }
        }
      })
  }

  function getStateDetails() {
    axios.post(environment.apiUrl + "/Master/getStateList")
      .then((response) => {

        if (response.data.status == 1) {
          setStateDetails(response.data.stateData)
        }
      })
  }


  function getLocationPreference() {
    axios.post(environment.apiUrl + "/Master/getLocationPreference")
      .then((response) => {

        if (response.data.status == 1) {
          setLocationPreferenceDetails(response.data.location_preferenceData)
        }
      })
  }
  return (
    <div className="container-fluid page-body-wrapper">
      <div className="col-sm-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Personal Details</h4>
            <form className="forms-sample" onSubmit={handleFormSubmit}>

              {/* Post & Preferences */}
              <div className="row">
                <div className="form-group col-sm-2">
                  <label>Post applied for <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    value={checkboxValue.post_applied || ''}
                    name="post_applied"
                    id="post_applied"
                    onChange={(event) => {
                      const postId = event.target.value;
                      setCheckboxValue({ ...checkboxValue, post_applied: postId });
                      if (postId) {
                        getLocationPreferenceByPost(postId);
                      } else {
                        setLocationPreferenceDetails([]);
                      }
                    }}
                  >
                    <option value="">Select Post Applied for</option>
                    {postDetails.map((value) => (
                      <option key={value.PositionID} value={value.PositionID}>
                        {value.PositionName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group col-sm-2">
                  <label>Preference 1 <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    id="location_preference1"
                    value={checkboxValue.location_preference1 || ''}
                    name="location_preference1"
                    onChange={(event) =>
                      setCheckboxValue({ ...checkboxValue, location_preference1: event.target.value })
                    }
                  >
                    <option value="">Select location applying for</option>
                    {locationPreferenceDetails.map((key) => (
                      <option key={key.location_preference} value={key.location_preference}>
                        {key.location_preference}
                      </option>
                    ))}
                  </select>
                </div>

                {showPref2 && (
                  <div className="form-group col-sm-2">
                    <label>Preference 2 <span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      id="location_preference2"
                      value={checkboxValue.location_preference2 || ''}
                      name="location_preference2"
                      onChange={(event) =>
                        setCheckboxValue({ ...checkboxValue, location_preference2: event.target.value })
                      }
                    >
                      <option value="">Select location applying for</option>
                      {locationPreferenceDetails.map((key) => (
                        <option key={key.location_preference} value={key.location_preference}>
                          {key.location_preference}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {showPref3 && (
                  <div className="form-group col-sm-2">
                    <label>Preference 3 <span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      id="location_preference3"
                      value={checkboxValue.location_preference3 || ''}
                      name="location_preference3"
                      onChange={(event) =>
                        setCheckboxValue({ ...checkboxValue, location_preference3: event.target.value })
                      }
                    >
                      <option value="">Select location applying for</option>
                      {locationPreferenceDetails.map((key) => (
                        <option key={key.location_preference} value={key.location_preference}>
                          {key.location_preference}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="form-group col-sm-4">
                  <label>Upload Photo <span className="text-danger">*</span></label>
                  <span>{picUpload.imagePath}</span>
                  <div className="input-group" style={{ gap:'1%'}}>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setSelectedFile(e.target.files[0])}
                      name="image"
                      id="image"
                    />
                    <button
                      type="button"
                      className="btn btn-danger"
                      style={{ backgroundColor:'#212121'}}
                      onClick={handlePhotoUpload}
                    >
                      Upload
                    </button>
                  </div>
                </div>

              </div>


              <div className="row">
                <div className="form-group col-sm-3">
                  <label>Title <span className="text-danger">*</span></label>
                  <select className="form-select" value={checkboxValue.title || ''} name="title" id="title" onChange={(event) => setCheckboxValue({ ...checkboxValue, title: event.target.value })}>
                    <option value="">Select Title</option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                  </select>

                </div>

                <div className="form-group col-sm-3">
                  <label>First Name <span className="text-danger">*</span></label>
                  <input type="text" name="first_name" readOnly={true} defaultValue={sessionStorage.getItem("first_name") || ""} className="form-control" id="first_name" placeholder="First Name" />
                </div>
                <div className="form-group col-sm-3">
                  <label>Middle Name</label>
                  <input type="text" name="middle_name" readOnly={true} defaultValue={(sessionStorage.getItem("middle_name")) || ""} className="form-control" id="middle_name" placeholder="Middle Name" />
                </div>
                <div className="form-group col-sm-3">
                  <label>Last Name <span className="text-danger">*</span></label>
                  <input type="text" name="last_name" readOnly={true} defaultValue={(sessionStorage.getItem("last_name")) || ""} className="form-control" id="last_name" placeholder="Last Name" />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-6">
                  <label>Email address <span className="text-danger">*</span></label>
                  <input type="email" name="email_id" readOnly={true} defaultValue={(sessionStorage.getItem("email_id")) || ""} className="form-control" id="email_id" placeholder="Email" />
                </div>
                <div className="form-group  col-sm-6">
                  <label>Contact Number <span className="text-danger">*</span></label>
                  <input type="number" name="mobile_no" readOnly={true} defaultValue={(sessionStorage.getItem("mobile_no")) || ""} className="form-control" id="mobile_no" placeholder="Contact Number" />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-3" hidden={true}>
                  <label>Category <span className="text-danger">*</span></label>
                  <select className="form-select" value={checkboxValue.category || ''} name="category" id="category" onChange={(event) => setCheckboxValue({ ...checkboxValue, category: event.target.value })}>
                    {/* <option value="">Select Category</option> */}
                    <option value="Un-Reserved">Un-Reserved</option>
                    <option value="EWS">EWS</option>
                    <option value="SC">SC</option>
                    <option value="ST">ST</option>
                    <option value="OBC">OBC</option>
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>DOB <span className="text-danger">*</span></label>
                  <input type="date" defaultValue={personalDetails.data.date_of_birth || ''} name="date_of_birth" className="form-control" id="dob" />
                </div>
                <div className="form-group col-sm-3">
                  <label>Date of entry into government service <span className="text-danger">*</span></label>
                  <input type="date" name="date_of_entry_into_govt_service" min={minFromDate} max={minToDate} onChange={(e) => fromDateChange(e)} defaultValue={personalDetails.data.date_of_entry_into_govt_service || ''} className="form-control" id="date_of_entry_into_govt_service" />
                </div>
                <div className="form-group col-sm-3">
                  <label>Date of retirement as per Parent cadre rules <span className="text-danger">*</span></label>
                  <input type="date" name="date_of_retirement_from_govt_service" min={maxFromDate} max={maxToDate} defaultValue={personalDetails.data.date_of_retirement_from_govt_service || ''} className="form-control" id="date_of_retirement_from_govt_service" />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-4">
                  <label>Last held Designation <span className="text-danger">*</span></label>
                  <input type="text" defaultValue={personalDetails.data.current_designation || ''} className="form-control" name="current_designation" id="current_designation" />
                </div>
                <div className="form-group col-sm-4">
                  <label>Last drawn pay as per the Pay Matrix (Cell & Level) <span className="text-danger">*</span></label>
                  <input type="text" defaultValue={personalDetails.data.current_pay_matrix || ''} className="form-control" name="current_pay_matrix" id="current_pay_matrix" />
                </div>
                <div className="form-group col-sm-4">
                  <label>Number of years in last held Level of Pay <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" defaultValue={personalDetails.data.no_of_yrs_current_pay_matrix || ''} name="no_of_yrs_current_pay_matrix" id="no_of_yrs_current_pay_matrix" />
                </div>
              </div>
              {/* <div className="row">
                  <div className="col-sm-12">
                    <label>Please state clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post <span className="text-danger">*</span></label>
                    <textarea className="form-control" defaultValue={personalDetails.data.state_whether_applicable_for_post_applying || ''}  name="state_whether_applicable_for_post_applying" id="state_whether_applicable_for_post_applying" rows="4" placeholder="State clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post"></textarea>
                  </div>
                </div> */}
              <div className="row">
                <div className="col-sm-4">
                  <label style={{ textAlign: 'left' }}>Please state clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post <span className="text-danger">*</span></label>
                  <select className="form-select" onChange={(event) => {
                    setPersonalDetails({ ...personalDetails, data: ({ state_whether_applicable_for_post_applying: event.target.value }) })

                  }} value={personalDetails.data.state_whether_applicable_for_post_applying || ''} name="state_whether_applicable_for_post_applying" id="state_whether_applicable_for_post_applying" rows="4" placeholder="State clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post">
                    <option value="">Please select Yes or No</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              <br />

              <div className="row">
                <div className="form-group col-sm-3">
                  <label>Present Address <span className="text-danger">*</span></label>
                  <textarea name="present_address" defaultValue={personalDetails.data.present_address || ''} onChange={(e) => {
                    setPermanentAddress(e.target.value)
                  }} className="form-control" id="present_address" rows="4" placeholder="Address"></textarea>
                </div>

                <div className="form-group col-sm-3">
                  <label>State <span className="text-danger">*</span></label>
                  <select name="present_state" id="present_state" value={checkboxValue.present_state || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, present_state: event.target.value })
                    getCityDetailsByStateId(event.target.value, 'present')
                  }} className="form-select">
                    <option value="">Select State</option>
                    {

                      stateDetails.map((key, value) => (

                        <option key={value} value={key.id}>{key.name}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>District <span className="text-danger">*</span></label>
                  <select name="present_district" value={checkboxValue.present_district || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, present_district: event.target.value })


                  }} className="form-select" id="present_district">
                    <option value="">Select District</option>
                    {

                      presentCityDetails.map((key, value) => (

                        <option key={value} value={key.city}>{key.city}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>Pin Code <span className="text-danger">*</span></label>
                  <input name="present_pincode" defaultValue={personalDetails.data.present_pincode
                    || ''} onChange={(e) => {

                      setPermanentPincode(e.target.value)


                    }} type="text" className="form-control" id="present_pin_code" />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-1">
                  <input name="check_box_address" defaultChecked={false} onChange={(e) => handleCheckBoxAddress(e)} type="checkbox" id="check_box_address" />
                </div>
                <div className="col-sm-8" style={{ textAlign: 'left' }}>
                  {/* style={{marginLeft: '-18%'}} */}
                  <label>Check this if present address is same as permanent address</label>

                </div>
              </div><br />
              <div className="row">
                <div className="form-group col-sm-3">
                  <label>Permanent Address <span className="text-danger">*</span></label>
                  <textarea name="permanent_address" defaultValue={personalDetails.data.permanent_address
                    || ''} id="permanent_address" className="form-control" rows="4" placeholder="Address"></textarea>
                </div>

                <div className="form-group col-sm-3">
                  <label>State <span className="text-danger">*</span></label>
                  <select name="permanent_state" value={checkboxValue.permanent_state || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, permanent_state: event.target.value })

                    getCityDetailsByStateId(event.target.value, 'permanent')
                  }} id="permanent_state" className="form-select">
                    <option value="">Select State</option>
                    {

                      stateDetails.map((key, value) => (

                        <option key={value} value={key.id}>{key.name}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>District <span className="text-danger">*</span></label>
                  <select name="permanent_district" value={checkboxValue.permanent_district || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, permanent_district: event.target.value })


                  }} id="permanent_district" className="form-select">
                    <option value="">Select District</option>
                    {

                      permanentCityDetails.map((key, value) => (

                        <option key={value} value={key.city}>{key.city}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>Pin Code <span className="text-danger">*</span></label>
                  <input name="permanent_pincode" defaultValue={personalDetails.data.permanent_pincode || ''} id="permanent_pincode" type="text" className="form-control" />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-3">
                  <label>Office Address</label>
                  <textarea name="office_address" defaultValue={personalDetails.data.office_address || ''} className="form-control" id="office_address" rows="4" placeholder="Address"></textarea>
                </div>

                <div className="form-group col-sm-3">
                  <label>State</label>
                  <select name="office_state" id="office_state" value={checkboxValue.office_state || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, office_state: event.target.value })
                    getCityDetailsByStateId(event.target.value, 'office')

                  }} className="form-select">
                    <option value="">Select State</option>
                    {

                      stateDetails.map((key, value) => (

                        <option key={value} value={key.id}>{key.name}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>District</label>
                  <select name="office_district" id="office_district" value={checkboxValue.office_district || ''} onChange={(event) => {

                    setCheckboxValue({ ...checkboxValue, office_district: event.target.value })


                  }} className="form-select">
                    <option value="">Select District</option>
                    {

                      officeCityDetails.map((key, value) => (

                        <option key={value} value={key.city}>{key.city}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="form-group col-sm-3">
                  <label>Pin Code</label>
                  <input name="office_pincode" defaultValue={personalDetails.data.office_pincode || ''} type="text" className="form-control" id="office_pincode" />
                </div>
              </div>
              <button type="submit" style={{ width: '100px' }} className="btn btn-primary me-2">Save</button>

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserPersonalDetails;
